const data = {
    module_name: "costos",
    title: "Costos",
    key: 'costos',
    category_key: "costos",
    excel_key: "costos"
}

module.exports = data